<template>
  <v-list-item v-if="!isEditing" avatar ripple class="it-hv">
    <abt-item-avatar :icon="'fal fa-map-marked-alt'" :note="printNote" />
    <v-list-item-content>
      <v-list-item-subtitle class="caption" v-if="!isPrintEmpty">希望地域</v-list-item-subtitle>
      <v-list-item-title v-if="isPrintEmpty">希望地域</v-list-item-title>
      <v-list-item-title v-else-if="isNoAnswer">回答なし</v-list-item-title>
      <v-list-item-title v-else>
        <span v-for="(item, idx) in getLocationLabelItems" :key="idx" class="caption grey lighten-2 pa-3 mr-1">{{ item }}</span>
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading" @click="edit">
            <v-icon small>fal fa-pencil</v-icon>
          </v-btn>
        </template>
        <span>編集する</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
  <v-container v-else>
    <v-subheader>希望地域</v-subheader>
    <v-row dense justify="end">
      <div class="text-xs-right">
        <v-switch color="blue darken-2" label="回答なし" v-model="config.ignore" @change="ignore"></v-switch>
      </div>
    </v-row>
    <v-row dense v-if="!isIgnore">
      <v-col cols="12" class="px-3">
        <span class="caption">地域の選択</span>
        <v-chip-group multiple column
          active-class="secondary white--text"
          v-model="form.locations.content">
          <v-chip
            v-for="item in getLocationItems"
            :key="`locations_content_${item.value}`"
            :value="item.value"
            :rules="rules.locations">{{ item.text }}</v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3">
        <v-text-field counter
          v-model="form.locations.note"
          label="希望地域の備考欄"
          maxlength="50"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import AbtItemAvatar from '../../../../components/avatar'
export default {
  name: 'clientAboutSurveyLocations',
  components: {
    AbtItemAvatar
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        ignore: false
      },
      form: {
        locations: {
          id: '',
          content: [],
          note: ''
        }
      },
      rules: {
        locations: [
          v => !!(v && v.length) || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props.data &&
        this.$props.data.locations
      ) {
        this.$set(this.config, 'ignore', !!(this.$props.data.locations.content && this.$props.data.locations.content === 'NONE'))
        this.$set(this.form, 'locations', {
          id: '' + (this.$props.data.locations.id ? this.$props.data.locations.id : 'new_locations'),
          content: this.$props.data.locations.content ? this.$props.data.locations.content.split(',') : [],
          note: this.$props.data.locations.note ? this.$props.data.locations.note : ''
        })
      } else {
        this.$set(this.form, 'locations', {
          id: 'new_locations',
          content: [],
          note: ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: 'locations'
        }
      })
    },
    ignore: function () {
      this.$set(this.form.locations, 'content', this.config.ignore ? ['NONE'] : [])
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        ['locations', 'all'].includes(this.$props.status.editing)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.status.editing === 'locations'
      )
    },
    isLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        ['locations', 'all'].includes(this.$props.status.loading)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.status.loading === 'locations'
      )
    },
    isIgnore () {
      return this.config.ignore
    },
    isNoAnswer () {
      return !!(
        this.$props.data &&
        this.$props.data.locations &&
        this.$props.data.locations.content &&
        this.$props.data.locations.content === 'NONE'
      )
    },
    isPrintEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.locations &&
        this.$props.data.locations.content
      )
    },
    printNote () {
      return (
        this.$props.data &&
        this.$props.data.locations &&
        this.$props.data.locations.note
      ) ? this.$props.data.locations.note : ''
    },
    isNoteEmpty () {
      return !(
        this.$props.data && this.$props.data.note
      )
    },
    getLocationItems () {
      return Object.keys(this.$mango.nations).filter(key => { return key !== 'JP' }).map(key => {
        return {
          text: this.$mango.nations[key],
          value: key
        }
      })
    },
    getLocationLabelItems () {
      return (
        this.$props.data &&
        this.$props.data.locations &&
        this.$props.data.locations.content
      ) ? this.$props.data.locations.content.split(',').map(key => {
          return (this.$mango.nations[key]) ? this.$mango.nations[key] : ''
        }) : []
    }
  }
}
</script>
